const initialState = "";
const changeActiveTab = (state = initialState, action) => {
  switch (action.type) {
    case "ACTIVE":
      return action.data;
    default:
      return state;
  }
};

export default changeActiveTab;
